import { render } from "./AnimatedBackground.vue?vue&type=template&id=2c2e1db7&scoped=true"
import script from "./AnimatedBackground.vue?vue&type=script&lang=js"
export * from "./AnimatedBackground.vue?vue&type=script&lang=js"

import "./AnimatedBackground.vue?vue&type=style&index=0&id=2c2e1db7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2e1db7"]])

export default __exports__